import React from 'react';
import { MenuIcon, BellIcon, UserIcon, LogOutIcon } from 'lucide-react';
import { useAuth } from '../auth/AuthContext';
export function Header() {
  const {
    user,
    logout
  } = useAuth();
  const handleLogout = () => {
    logout();
    window.location.href = '/signin';
  };
  return <header className="bg-white border-b border-gray-200" data-id="element-219">
      <div className="flex justify-between items-center px-6 py-4" data-id="element-220">
        <div className="flex items-center" data-id="element-221">
          <img src="https://cdn.magicpatterns.com/uploads/ssm8opUN7FjpcwsqK5Tnq3/accrue_logo.png" alt="Accrue" className="h-20" data-id="element-222" />
        </div>
        <div className="flex items-center space-x-4" data-id="element-223">
          <button className="p-2 text-gray-500 hover:text-gray-700 focus:outline-none" data-id="element-224">
            <BellIcon size={20} data-id="element-225" />
          </button>
          <div className="relative group" data-id="element-226">
            <button className="p-2 text-gray-500 hover:text-gray-700 focus:outline-none flex items-center" data-id="element-227">
              <UserIcon size={20} className="mr-2" data-id="element-228" />
              <span className="hidden md:block text-sm font-medium text-gray-700" data-id="element-229">
                {user?.firstName || 'User'}
              </span>
            </button>
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 hidden group-hover:block" data-id="element-230">
              <button onClick={handleLogout} className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-231">
                <LogOutIcon size={16} className="mr-2" data-id="element-232" />
                Sign out
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>;
}